// danish language
export default {
  actions:{
    buy:'Kaufen',
    cancel:'Abbrechen',
    book:'Buchen',
    reserve: 'Reservieren',
    download: 'Herunterladen' //
  },
  label:{
    price:'Preis',
    afterDiscount:'Nach Rabatt',
    color:'Farbe',
    qty:'Beschreibung',
    desc:'Description',
    speci:'Spezifikationen',
    video:'Volles Video ansehen',
    readmore:'Mehr anzeigen',
    showless:'Weniger anzeigen',
    choose:'Wählen Sie unten aus:',
    submit:'Einreichen',
    deliverTime:'Lieferzeit wählen',
    selectArea:'Gebiet wählen',
    selectCity:'Stadt wählen',
    select:'Wählen'

  },
  images:{
    noImages:'Keine Bilder'
  },
  tableLabels:{
    en: [
      {
        key: "name",
        label: "Spezifikationen"
      },
      {
        key: "value",
        label: ""
      }
    ],
  },
  orderCart: {
    label: "Bestellung bearbeiten",
    remove: "Entfernen",
    increase: "+",
    decrease: "-",
    addProduct: "Artikel hinzufügen",
    confirm: "Zur Kasse",
    cancel:"Schließen",
    subtotal: "Zwischensumme",
    tax: "Steuer",
    delivery: "Liefergebühren",
    total: "Gesamt ",
    discount: "Rabatt",
    note: "Notizen:",
    empty_order: "Ihr Warenkorb ist leer!",
    zero: 0.00,
    edit:'Bearbeiten',
    delete:'Löschen',
    noItem:'0 Artikel in Ihrem Warenkorb',
    browsing:'Beginnen Sie zu stöbern'
  },
  notify:{
    errorInput:"Etwas ist schiefgelaufen, alle Felder müssen ausgefüllt werden",
    confirmErr:"Etwas ist schiefgelaufen, Sie haben noch nichts hinzugefügt",
    error:"Etwas ist schiefgelaufen",
    emptyList:"Ihr Warenkorb ist leer!",
    largeFile: "Datei ist zu groß!",
    maxSize: "Maximale Größe ist",
    support: "Datei wird nicht unterstützt!",
    uploadError : "Datei konnte aus irgendeinem Grund nicht hochgeladen werden, bitte versuchen Sie es erneut.",
    multiFilesUpload: "Kann nicht mehr hochladen ",
    multiFiles: "Dateien auf einmal!",
    noInternet : "Keine Internetverbindung, bitte versuchen Sie es erneut!"
  },
  placeHolder:{
    input:"Eingeben ",
    messageInput: "Nachricht schreiben ..."
  },
  captureLead:{
    phoneValidation:'Ungültige Telefonnummer',
    emailValidation: 'Ungültige E-Mail',
    hello: "Hallo!"
  },
  footer: { 
    poweredBy: "Bereitgestellt von"
  },
  chatBody: {
    typingIndicator: "Botten tænker...",
  },
};
